import { render } from "./EasyAccess.vue?vue&type=template&id=6337199e&scoped=true"
import script from "./EasyAccess.vue?vue&type=script&lang=js"
export * from "./EasyAccess.vue?vue&type=script&lang=js"

import "./EasyAccess.vue?vue&type=style&index=0&id=6337199e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6337199e"]])

export default __exports__